import { render, staticRenderFns } from "./lvshi.vue?vue&type=template&id=138d1bf4&scoped=true"
import script from "./lvshi.vue?vue&type=script&lang=js"
export * from "./lvshi.vue?vue&type=script&lang=js"
import style0 from "./lvshi.vue?vue&type=style&index=0&id=138d1bf4&prod&scoped=true&lang=less"
import style1 from "./lvshi.vue?vue&type=style&index=1&id=138d1bf4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d1bf4",
  null
  
)

export default component.exports